var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "conversation-list d-flex flex-column conversation-list-root"
    },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-column align-center justify-center az-gap mb-4"
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex align-center w-100",
              class: _vm.emptyStateRich
                ? "justify-space-between"
                : "justify-center"
            },
            [
              _c("input-by-type", {
                staticClass: "mr-2",
                attrs: {
                  value: _vm.searchText,
                  type: "search",
                  placeholder: "Buscar conversa...",
                  "data-test": "conversation-search",
                  clearable: ""
                },
                on: {
                  input: function($event) {
                    _vm.searchText = $event
                  }
                }
              }),
              _c(
                "div",
                { staticClass: "d-flex align-center justify-end" },
                [
                  _vm.podeResumirComIa
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "span",
                                      _vm._g({}, on),
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "nova-conversa-btn mr-1",
                                            attrs: {
                                              "data-test":
                                                "resumir-nao-lidas-btn",
                                              "x-small": "",
                                              icon: "",
                                              color: "primary",
                                              fab: "",
                                              loading: _vm.preparandoResumo
                                            },
                                            on: {
                                              click: _vm.resumirNaoLidasComIa
                                            }
                                          },
                                          [
                                            _c("icon-svg", {
                                              attrs: {
                                                name: "ai-sparkle",
                                                size: "16",
                                                color: "white"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2709462695
                          )
                        },
                        [_c("span", [_vm._v("Resumir não lidas com a IA")])]
                      )
                    : _vm._e(),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            return [
                              _c(
                                "span",
                                _vm._g({}, on),
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "nova-conversa-btn",
                                      attrs: {
                                        "data-test": "nova-conversa-btn",
                                        "x-small": "",
                                        icon: "",
                                        color: "primary",
                                        fab: "",
                                        disabled: !_vm.hasActiveConexoes
                                      },
                                      on: { click: _vm.onNovaConversa }
                                    },
                                    [
                                      _c("icon-svg", {
                                        attrs: {
                                          name: _vm.icons.plus,
                                          size: "16",
                                          color: "#FFFFFF"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.hasActiveConexoes
                                ? "Nova conversa"
                                : "Conecte um WhatsApp para iniciar conversas"
                            ) +
                            " "
                        )
                      ])
                    ]
                  ),
                  _c("ConexaoActionsMenu", {
                    attrs: {
                      conexoes: _vm.conexoes,
                      refreshing: _vm.refreshing,
                      "connected-conexoes": _vm.connectedConexoes
                    },
                    on: {
                      "conexao-updated": _vm.onConexaoUpdated,
                      "refresh-chats-list": _vm.onRefreshChatsListFromMenu
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("BaseToggleButton", {
            staticClass: "toggle-full-width",
            attrs: {
              value: _vm.tipoFilter,
              options: _vm.tiposFiltro,
              buttonStyle: _vm.panelStyle,
              small: ""
            },
            on: { input: _vm.selectTipo }
          })
        ],
        1
      ),
      _vm.showConexaoFilter
        ? _c(
            "div",
            {
              staticClass: "conexao-filter-bar mb-4",
              style: { backgroundColor: _vm.conexaoBarBg },
              attrs: { "data-test": "conexao-filter-bar" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "conexao-filter-bar__header d-flex align-center px-3 py-2",
                  on: {
                    click: function($event) {
                      _vm.conexaoExpanded = !_vm.conexaoExpanded
                    }
                  }
                },
                [
                  _c("icon-svg", {
                    staticClass: "mr-2",
                    attrs: {
                      name: _vm.icons.connections,
                      size: "14",
                      color: "primary"
                    }
                  }),
                  _c(
                    "span",
                    {
                      staticClass:
                        "az-text-small font-medium flex-grow-1 text-truncate"
                    },
                    [_vm._v(" " + _vm._s(_vm.selectedConexaoName) + " ")]
                  ),
                  _c("icon-svg", {
                    attrs: {
                      name: _vm.conexaoExpanded
                        ? "mdi-chevron-up"
                        : "mdi-chevron-down",
                      size: "16"
                    }
                  })
                ],
                1
              ),
              _c("v-expand-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.conexaoExpanded,
                        expression: "conexaoExpanded"
                      }
                    ],
                    staticClass: "px-3 pb-2"
                  },
                  [
                    _c("input-by-type", {
                      staticClass: "align-icon-search",
                      attrs: {
                        type: "autocomplete",
                        value: _vm.conexaoFilter,
                        options: _vm.conexaoOptions,
                        dense: "",
                        "hide-details": "",
                        "data-test": "conexao-filter"
                      },
                      on: { input: _vm.onConexaoFilter }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm.loadingConversas && !_vm.hasConversas
        ? _c(
            "div",
            { staticClass: "flex-grow-1 pb-2" },
            _vm._l(10, function(i) {
              return _c(
                "div",
                {
                  key: "skeleton-" + i,
                  staticClass: "d-flex align-center pa-2 mb-1"
                },
                [
                  _c("BaseLoadingSkeleton", {
                    staticClass: "mr-2 rounded-circle",
                    staticStyle: { "border-radius": "999px" },
                    attrs: { width: "32px", height: "32px" }
                  }),
                  _c(
                    "div",
                    { staticClass: "flex-grow-1" },
                    [
                      _c("BaseLoadingSkeleton", {
                        staticClass: "mb-1",
                        attrs: {
                          width: _vm.skeletonWidths[i - 1][0] + "px",
                          height: "14px"
                        }
                      }),
                      _c("BaseLoadingSkeleton", {
                        attrs: {
                          width: _vm.skeletonWidths[i - 1][1] + "px",
                          height: "12px"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            0
          )
        : _vm.hasConversas
        ? _c(
            "div",
            {
              staticClass:
                "conversation-list__items overflow-y-auto flex-grow-1"
            },
            [
              _vm._l(_vm.sortedConversas, function(conversa) {
                return _c("ConversationListItem", {
                  key: conversa.id,
                  attrs: {
                    conversa: conversa,
                    conexoes: _vm.conexoes,
                    selected:
                      _vm.selectedConversa &&
                      _vm.selectedConversa.id === conversa.id
                  },
                  on: { click: _vm.onSelectConversa }
                })
              }),
              _vm.loadingMore
                ? _c(
                    "div",
                    {
                      staticClass: "d-flex align-center justify-center py-3",
                      attrs: { "data-test": "load-more-indicator" }
                    },
                    [
                      _c("v-progress-circular", {
                        staticClass: "mr-2",
                        attrs: {
                          indeterminate: "",
                          size: "16",
                          width: "2",
                          color: "primary"
                        }
                      }),
                      _c("span", { staticClass: "az-text-small az-muted" }, [
                        _vm._v("Carregando mais...")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        : _vm.emptyStateRich && !_vm.hasAnyConversas && _vm.conexaoCta.type
        ? _c(
            "div",
            {
              staticClass:
                "d-flex flex-column align-center justify-center flex-grow-1 px-4 no-conversas-container",
              attrs: { "data-test": "empty-state-conexao-cta" }
            },
            [
              _c("icon-svg", {
                staticClass: "mb-4",
                attrs: {
                  name: _vm.icons.chatOutline,
                  size: "64",
                  color: "#8E8E8E"
                }
              }),
              _c(
                "span",
                {
                  staticClass:
                    "az-text-primary az-size-16 font-medium az-muted",
                  attrs: { "data-test": "conexao-cta-title" }
                },
                [_vm._v(" " + _vm._s(_vm.conexaoCta.title) + " ")]
              ),
              _c(
                "span",
                {
                  staticClass:
                    "az-text-small text-center mt-1 az-muted empty-state-description",
                  attrs: { "data-test": "conexao-cta-description" }
                },
                [_vm._v(" " + _vm._s(_vm.conexaoCta.description) + " ")]
              ),
              _vm.conexaoCta.type === _vm.ctaTypes.CONFIG
                ? _c(
                    "router-link",
                    {
                      staticClass: "az-text-small primary--text mt-4",
                      attrs: {
                        to: { name: "settings-v2.atendimento.conexoes" },
                        "data-test": "conexao-cta-config-link"
                      }
                    },
                    [_vm._v(" Ir para Configurações ")]
                  )
                : _vm.conexaoCta.type === _vm.ctaTypes.SCAN_QRCODE
                ? _c(
                    "v-menu",
                    {
                      attrs: {
                        "max-width": "640",
                        top: "",
                        "open-on-hover": "",
                        "close-on-content-click": false
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            return [
                              _c(
                                "span",
                                _vm._g(
                                  {
                                    staticClass:
                                      "cursor-help d-inline-flex align-center az-text-small primary--text mt-3"
                                  },
                                  on
                                ),
                                [
                                  _c("icon-svg", {
                                    staticClass: "mr-1",
                                    attrs: {
                                      name: "mdi-information",
                                      size: "14",
                                      color: "var(--primary)"
                                    }
                                  }),
                                  _vm._v(" Ver tutorial passo a passo ")
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.tutorialMenuActive,
                        callback: function($$v) {
                          _vm.tutorialMenuActive = $$v
                        },
                        expression: "tutorialMenuActive"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "az-card pa-4" },
                        [
                          _c("span", { staticClass: "az-text-small" }, [
                            _vm._v(" Clique no menu de ações "),
                            _c("b", [_vm._v("⋮")]),
                            _vm._v(
                              " no topo da lista de conversas e selecione "
                            ),
                            _c("b", [_vm._v("Conectar via QR Code")]),
                            _vm._v(
                              ". Um modal abrirá com o código para pareamento no WhatsApp. "
                            )
                          ]),
                          _c("v-divider", { staticClass: "my-3" }),
                          _c("ConexaoQrcodeAnimatedSvg")
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm.emptyStateRich && !_vm.hasAnyConversas
        ? _c(
            "div",
            {
              staticClass:
                "d-flex flex-column align-center justify-center flex-grow-1 px-4 no-conversas-container",
              attrs: { "data-test": "empty-state-rich" }
            },
            [
              _c("icon-svg", {
                staticClass: "mb-4",
                attrs: {
                  name: _vm.icons.chatOutline,
                  size: "64",
                  color: "#8E8E8E"
                }
              }),
              _c(
                "span",
                {
                  staticClass: "az-text-primary az-size-16 font-medium az-muted"
                },
                [_vm._v(" Selecione ou inicie uma conversa ")]
              ),
              _vm._m(0),
              _c(
                "BaseButton",
                {
                  staticClass: "mt-4",
                  attrs: {
                    primary: "",
                    "min-width": "200px",
                    disabled: !_vm.hasActiveConexoes
                  },
                  on: { click: _vm.onNovaConversa }
                },
                [
                  _vm._v(" + "),
                  _c("span", { staticClass: "ml-1" }, [_vm._v("Nova Conversa")])
                ]
              )
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass:
                "d-flex flex-column align-center justify-center flex-grow-1 pa-4 no-conversas-container",
              attrs: { "data-test": "empty-state" }
            },
            [
              _c("icon-svg", {
                staticClass: "mb-3",
                attrs: {
                  name: _vm.icons.messageTextOutline,
                  size: "48",
                  color: "#8E8E8E"
                }
              }),
              _c(
                "span",
                {
                  staticClass: "az-text-primary az-size-14 az-muted text-center"
                },
                [_vm._v(" Nenhuma conversa encontrada ")]
              )
            ],
            1
          )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass:
          "az-text-small text-center mt-1 az-muted empty-state-description"
      },
      [
        _vm._v(" Escolha uma das conversas ao lado, ou toque em "),
        _c("strong", [_vm._v('"Nova Conversa"')]),
        _vm._v(
          " no topo da lista para começar uma conversa com qualquer número. "
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }